// Central data-testid catalog for Sur Primicia
export const TID = {
  // Layout
  header: "site-header",
  headerLogo: "header-logo-link",
  headerDate: "header-current-date",
  mobileMenuButton: "mobile-menu-button",
  mobileMenu: "mobile-menu",
  searchInput: "header-search-input",
  searchInputMobile: "mobile-search-input",
  searchSubmit: "header-search-submit",
  socialFacebook: "social-facebook",
  socialTwitter: "social-twitter",
  socialInstagram: "social-instagram",
  socialYoutube: "social-youtube",
  navCategoryLink: (slug) => `nav-category-${slug}`,
  mobileNavCategoryLink: (slug) => `mobile-nav-category-${slug}`,
  breakingBar: "breaking-news-bar",
  footer: "site-footer",

  // Home
  homePage: "home-page",
  heroArticle: "hero-article",
  featuredGrid: "featured-grid",
  latestBlock: "latest-block",
  todayBlock: "home-today-block",
  mostReadBlock: "most-read-block",
  cityBlockRioGrande: "block-city-rio-grande",
  cityBlockUshuaia: "block-city-ushuaia",
  cityBlockTolhuin: "block-city-tolhuin",
  policeBlock: "block-policiales",
  sportsBlock: "block-deportes",
  videosBlock: "block-videos",
  generalGrid: "general-grid",

  // News card
  newsCard: (id) => `news-card-${id}`,
  newsCardLink: (id) => `news-card-link-${id}`,

  // Category page
  categoryPage: "category-page",
  categoryTitle: "category-title",
  categoryPagePrev: "category-page-prev",
  categoryPageNext: "category-page-next",

  // Article page
  articlePage: "article-page",
  articleTitle: "article-title",
  articleSummary: "article-summary",
  articleAuthor: "article-author",
  articleDate: "article-date",
  articleContent: "article-content",
  shareFacebook: "share-facebook",
  shareWhatsapp: "share-whatsapp",
  shareX: "share-x",
  shareTelegram: "share-telegram",
  shareCopy: "share-copy",
  relatedList: "related-list",

  // Search
  searchPage: "search-page",
  searchQuery: "search-page-query",

  // Contact
  contactPage: "contact-page",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactSubject: "contact-subject",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",

  // About
  aboutPage: "about-page",

  // Privacy
  privacyPage: "privacy-page",

  // 404
  notFoundPage: "not-found-page",
  goHomeLink: "go-home-link",
};
